import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="pt-32 pb-24 bg-zinc-950 min-h-screen selection:bg-orange-500 selection:text-zinc-950">
      <div className="container mx-auto px-6 md:px-12 max-w-4xl">
        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-4xl md:text-6xl font-black uppercase tracking-tighter text-white mb-4">
            Datenschutz<span className="text-orange-500 text-3xl md:text-5xl">erklärung</span><span className="text-orange-500">.</span>
          </h1>
          <div className="w-20 h-2 bg-orange-500 mb-12"></div>

          <div className="space-y-12 text-zinc-400 leading-relaxed font-medium">
            {/* Section 1 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-6 uppercase tracking-wide border-l-4 border-orange-500 pl-4">
                1. Datenschutz auf einen Blick
              </h2>
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-bold text-zinc-200 mb-2">Allgemeine Hinweise</h3>
                  <p>Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.</p>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-zinc-200 mb-2">Datenerfassung auf dieser Website</h3>
                  <h4 className="text-white font-bold mb-1">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</h4>
                  <p className="mb-4">Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle“ in dieser Datenschutzerklärung entnehmen.</p>
                  
                  <h4 className="text-white font-bold mb-1">Wie erfassen wir Ihre Daten?</h4>
                  <p className="mb-4">Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben. Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).</p>
                  
                  <h4 className="text-white font-bold mb-1">Wofür nutzen wir Ihre Daten?</h4>
                  <p>Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.</p>
                </div>
              </div>
            </section>

            {/* Section 2 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-6 uppercase tracking-wide border-l-4 border-orange-500 pl-4">
                2. Hosting
              </h2>
              <p className="mb-4">Wir hosten die Inhalte unserer Website bei folgendem Anbieter:</p>
              <h3 className="text-lg font-bold text-zinc-200 mb-2">Externes Hosting</h3>
              <p className="mb-4">Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert. Das externe Hosting erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und effizienten Bereitstellung unseres Online-Angebots.</p>
              <div className="bg-zinc-900 p-6 border border-zinc-800 rounded-sm">
                <p className="text-white font-bold mb-2 underline decoration-orange-500">Wir setzen folgenden Hoster ein:</p>
                <p>
                  Netlify, Inc.<br />
                  2325 3rd Street, Suite 296<br />
                  San Francisco, CA 94107<br />
                  USA
                </p>
              </div>
            </section>

            {/* Section 3 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-6 uppercase tracking-wide border-l-4 border-orange-500 pl-4">
                3. Allgemeine Hinweise und Pflichtinformationen
              </h2>
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-bold text-zinc-200 mb-2">Hinweis zur verantwortlichen Stelle</h3>
                  <div className="text-zinc-300">
                    <p className="font-bold text-white">Valeri Rudt</p>
                    <p>Westring 9a</p>
                    <p>59423 Unna</p>
                    <p className="mt-2 text-orange-500">E-Mail: info@valerirudtmedia.de</p>
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-zinc-200 mb-2">Speicherdauer</h3>
                  <p>Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt.</p>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-zinc-200 mb-2">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
                  <p>Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.</p>
                </div>
              </div>
            </section>

            {/* Section 4 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-6 uppercase tracking-wide border-l-4 border-orange-500 pl-4">
                4. Datenerfassung auf dieser Website
              </h2>
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-bold text-zinc-200 mb-2">Cookies</h3>
                  <p>Unsere Internetseiten verwenden so genannte „Cookies“. Cookies sind kleine Datenpakete und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert.</p>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-zinc-200 mb-2">CCM19</h3>
                  <p className="mb-4">Unsere Website nutzt CCM19, um Ihre Einwilligung zur Speicherung bestimmter Cookies auf Ihrem Endgerät oder zum Einsatz bestimmter Technologien einzuholen und diese datenschutzkonform zu dokumentieren.</p>
                  <p className="text-sm italic">Anbieter: Papoo Software & Media GmbH, Auguststr. 4, 53229 Bonn.</p>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-zinc-200 mb-2">Server-Log-Dateien</h3>
                  <p>Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind u.a. Browsertyp, Betriebssystem, Referrer URL und Hostname des zugreifenden Rechners.</p>
                </div>
              </div>
            </section>
          </div>
        </motion.div>
      </div>
    </main>
  );
};

export default Privacy;